const STORAGE_KEY = 'planb_attribution';
const ATTRIBUTION_PARAMS = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
  'campaign_id', 'campaign_name', 'adset_id', 'adset_name', 'ad_id', 'ad_name',
];
const WINDOW_DAYS = 30;

// Reads ad-click params from the current URL, if present, and overwrites
// any previously stored attribution (last-touch wins). Safe to call on
// every route change — it's a no-op when the URL has none of these params.
export function captureAttributionFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  let hasAny = false;

  ATTRIBUTION_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      found[key] = value;
      hasAny = true;
    }
  });

  if (!hasAny) return;

  let type = 'other';
  if (found.utm_source) type = found.utm_source.toLowerCase();
  else if (found.campaign_id) type = 'meta';

  const payload = { type, ...found, captured_at: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
}

// Returns the stored attribution if it's still within the 30-day window,
// otherwise null (and clears the stale entry).
export function getStoredAttribution() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    const ageDays = (Date.now() - new Date(parsed.captured_at).getTime()) / 86400000;
    if (ageDays > WINDOW_DAYS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}